// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "activity-" + chunkId + ".js?v=" + {"139":"d32244793918f4e8d34b","620":"85b59bf04dde1e9594fc"}[chunkId] + "";
};